import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from '../../../../../library/form/components/FormWrapper';

const ProdIOOOutViewRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn30">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "outputQty" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "outputDate" }} />
                </li>
            </ul>
        )
}

export default ProdIOOOutViewRow